<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Requirements" />

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Minutes Required" label-position="inside">
                        <b-input v-model="app.min_minutes_required" placeholder="0"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Sessions Required" label-position="inside">
                        <b-input v-model="app.min_sessions_required" placeholder="0"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Max Units" label-position="inside">
                        <b-input v-model="app.max_units" placeholder="0"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Required Session(s)" message="Control-Click to Select Multiple">
                        <b-select v-model="app.requiredSessions" multiple native-size="5" expanded>
                            <option :value="session.id" v-for="session in app.conferences.conf_sessions">{{ session.title }}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-align-left" title="Settings" />

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Default Flat Price" label-position="inside">
                        <b-input v-model="app.flat_price" placeholder="0.00"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Default Price-per-Unit" label-position="inside">
                        <b-input v-model="app.per_unit_price" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_active">Visible (Active)</b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_enabled">Is Enabled</b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_required_at_end">Required (Display Notice)</b-switch>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-timer" title="Scheduled Settings" />


        <card-list-item class="pb-5" v-for="c in app.conf_application_prices" no-hover no-cursor>
            <template #icon><i class="fa-fw fas fa-timer"></i></template>
            <template #content>
                <div class="columns" v-if="c.edit">
                    <div class="column">
                        <price-schedule-form :price="c" />
                    </div>
                    <div class="column is-2 has-text-right">
                        <b-field position="is-right" grouped>
                            <p class="control">
                                <b-button class="button is-danger" outlined size="is-small" @click="deletePrice(c)"><i class="far fa-times"></i></b-button>
                            </p>
                            <p class="control">
                                <b-button class="button is-primary" size="is-small" @click="updatePrice(c)"><i class="far fa-check"></i></b-button>
                            </p>
                        </b-field>
                    </div>
                </div>
                <div class="columns" v-else>
                    <div class="column">
                        <price-schedule :price="c" />
                    </div>
                    <div class="column is-2 has-text-right">
                        <b-field position="is-right">
                            <p class="control">
                                <b-button class="button is-primary" outlined @click="c.edit=true"><i class="far fa-pencil"></i></b-button>
                            </p>
                        </b-field>
                    </div>
                </div>
            </template>
        </card-list-item>

        <card-list-item class="pb-5" no-hover no-cursor>
            <template #icon><i class="fa-fw fas fa-plus"></i></template>
            <template #content>
                <div class="columns">
                    <div class="column">
                        <price-schedule-form :price="newPrice" />
                    </div>
                    <div class="column is-2 has-text-right">
                        <p class="control">
                            <button class="button is-success" :disabled="!newPrice.enabled_at || !newPrice.disabled_at" @click="addPrice"><i class="far fa-fw fa-plus"></i></button>
                        </p>
                    </div>
                </div>
            </template>
        </card-list-item>

        <subheader-list-item icon="fa-file-alt" title="Compliance" />

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Syllabus" label-position="inside">
                        <b-input type="textarea" v-model="app.syllabus"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Goals" label-position="inside">
                        <b-input type="textarea" v-model="app.goals"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Objectives" label-position="inside">
                        <b-input type="textarea" v-model="app.objectives"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Outcomes" label-position="inside">
                        <b-input type="textarea" v-model="app.outcomes"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Learning Standards" label-position="inside">
                        <b-input type="textarea" v-model="app.standards"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Instructor" label-position="inside">
                        <b-input v-model="app.instructor"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Resume" label-position="inside">
                        <b-input type="textarea" v-model="app.resume"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Expected Participants" label-position="inside">
                        <b-input type="number" v-model="app.num_participants"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import PriceScheduleForm from "./PriceScheduleForm.vue";
    import PriceSchedule from "./PriceSchedule.vue";
    import {client as http} from '@/http_client';

    export default {
        name: 'ConfApplicationForm',
        props: {
            app: {
                type: Object,
                required: true
            },
        },
        components: {PriceSchedule, PriceScheduleForm, SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function () {
            return {
                newPrice: {
                    flat_price: '0',
                    per_unit_price: '0',
                    enabled_at: null,
                    disabled_at: null,
                    edit: false
                }
            };
        },
        methods: {
            addPrice: function () {
                http.post('conferences/' + this.app.conference_id + '/applications/' + this.app.id + '/prices', {conf_application_id: this.app.id, ...this.newPrice}).then(response => {
                    this.app.conf_application_prices.push({...this.newPrice, id: response.data.id});
                    this.newPrice = {
                        flat_price: '0',
                        per_unit_price: '0',
                        enabled_at: null,
                        disabled_at: null,
                        edit: false
                    };
                }).catch(err => {
                    console.log(err);
                    window.alert('Error adding price schedule');
                });
            },
            updatePrice: function (c) {
                http.put('conferences/' + this.app.conference_id + '/applications/' + this.app.id + '/prices/' + c.id, c).then(response => {
                    c.edit = false;
                }).catch(err => {
                    console.log(err);
                    window.alert('Error updating price schedule');
                });
            },
            deletePrice: function (c) {
                console.log(c)
                if (window.confirm('Are you sure you want to delete this price schedule?')) {
                    http.delete('conferences/' + this.app.conference_id + '/applications/' + this.app.id + '/prices/' + c.id).then(response => {
                        this.app.conf_application_prices.splice(this.app.conf_application_prices.indexOf(c), 1);
                    }).catch(err => {
                        console.log(err);
                        window.alert('Error deleting price schedule');
                    });
                }
            },
        }
    };
</script>
